import React, { FunctionComponent } from 'react';
import { Company, DataCategory, DataValueCompanyPageRecruitments } from '../../../types/companyDetail';
import { CompanyDetailRecruitmentsChild } from '../../molecules/companyDetailRecruitmentsChild';

type Props = {
  recruitmentIds: number[];
  company: Company
  coverNoImg: string;
  dataCategory: DataCategory;
  dataValue: DataValueCompanyPageRecruitments;
};

export const Presentation: FunctionComponent<Props> = ({
  recruitmentIds,
  company,
  coverNoImg,
  dataCategory,
  dataValue,
}) => {
  if (!recruitmentIds || recruitmentIds.length === 0) return null;

  return (
    <section className="company__page__recruitments css-slider" id="recruitments">
      <div className="company__page__recruitments__header">
        <h2 className="company__page__recruitments__header--title">求人</h2>
        {company && (
          <a
            href={`/companies/${company.id}/recruitments`}
            className="company__page__recruitments__header--link gtm-button-view-count"
            data-event-name='button on screen'
            data-event="click"
            data-category={dataCategory}
            data-value={dataValue.moreSelfRecruitments}
          >
            すべての求人を見る
          </a>
        )}
      </div>

      <div className="company__page__recruitments__wrapper slides">
        {recruitmentIds.map((id) => (
          <CompanyDetailRecruitmentsChild
            key={id}
            id={id}
            coverNoImg={coverNoImg}
            company={company}
            dataCategory={dataCategory}
            dataValue={dataValue}
          />
        ))}
      </div>
    </section>
  );
};
